<template>
    <div class="mt-2 mb-2 ml-3">
        <div v-if="logs.length" class="mt-2">
            <div
                class="title mt-2 mb-4 pb-2 layout row"
                style="text-decoration: underline;"
            >
                Change Logs
            </div>

            <v-divider class="pb-1"></v-divider>
            <v-layout row class="mb-2">
                <div class="width-200 font-weight-medium">Date</div>
                <div class="width-100 font-weight-medium">Key</div>
                <div class="width-100 font-weight-medium">Action</div>
                <div class="width-400 font-weight-medium">User</div>
                <div class="width-200 font-weight-medium">Changes</div>
            </v-layout>
            <v-divider class="pb-1"></v-divider>
            <div class="my-2" v-for="(log, index) in logs">
                <v-layout row class="py-2">
                    <div class="width-200">
                        {{ log.dateTime | time }}
                    </div>
                    <div class="width-100">
                        {{ log.keyValues }}
                    </div>
                    <div class="width-100">{{ log.action }}</div>
                    <div class="width-400">
                        {{ log.userName }}
                    </div>
                    <div
                        class="width-200"
                        style="white-space: pre-line; margin-top: -20px;"
                    >
                        {{ log.changes }}
                    </div>
                </v-layout>
                <v-divider
                    class="pb-1"
                    v-if="index + 1 < logs.length"
                ></v-divider>
            </div>
        </div>
        <div class="title mt-0" v-if="!loading && !logs.length">
            No Change Logs
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, sum } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            loading: true,
            logs: [],
        };
    },
    async created() {
        this.loadLogs();
    },
    computed: {},
    methods: {
        async loadLogs() {
            if (!this.row.accountID) return;

            const response = await this.$http.get(
                "api/vmAccountStatus/GetChangeLogs?accountID=" +
                    this.row.accountID,
            );

            this.loading = false;

            this.logs = response;
        },
        // getRowProperties() {
        //     return Object.keys(
        //         except(
        //             this.match,
        //             "vgt_id",
        //             "originalIndex",
        //             "vgtExpended",
        //         )
        //     )
        //         .map((key) => {
        //             const column = this.columns
        //                 .filter((c) => !c.isIcon)
        //                 .find((c) => c.field == key);

        //             return {
        //                 name: column ? column.label : toTitleCase(key),
        //                 value: this.row[key],
        //             };
        //         })
        //         .filter((p) => p.value);
        // },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
    },
};
</script>
<style></style>
